// extracted by mini-css-extract-plugin
export default {"upload":"T8p9Z"};